
export default {
    name: "BlockBlok",
    props: {
        blok: {
            type: Object,
            required: true,
        },
    },
    computed: {
        isDiagonal(direction, breakpoint) {
            const blokValue = this.blok.diagonalBorders
            const key = `${direction}-${breakpoint}`
            return blokValue?.includes(key) ?? false
        },
        diagonalClasses() {
            if (!this.blok.diagonalBorders) return []

            return this.blok.diagonalBorders.map((border) => {
                return `diagonal--${border}`
            })
        },
        classes() {
            return [
                ...this.diagonalClasses,
                {
                    diagonal: this.isDiagonal,
                    "storyblok-fullwidth":
                        this.useInnerSpacing || this.blok.fullwidth,
                    "storyblok-viewheight": !!this.blok.viewheight,
                },
            ]
        },
        innerClasses() {
            return [
                this.blok.viewheight,
                {
                    "storyblok-spacing": this.useInnerSpacing,
                },
            ]
        },
        useInnerSpacing() {
            const hasBackground =
                this.blok.background ||
                this.blok.backgroundImage?.filename ||
                this.blok.backgroundImageDesktop?.filename
            return hasBackground
        },
        style() {
            const style = {}
            if (this.blok.background) {
                style.background = this.blok.background
            }
            if (this.blok.backgroundImage || this.blok.backgroundImageDesktop) {
                style.backgroundImage = `url(${this.blok.backgroundImage.filename})`
                if (
                    this.$breakpoint.mdAndUp &&
                    this.blok.backgroundImageDesktop?.filename
                ) {
                    style.backgroundImage = `url(${this.blok.backgroundImageDesktop.filename})`
                }
            }
            if (this.blok.minHeight || this.blok.minHeightDesktop) {
                style.minHeight = this.blok.minHeight
                if (this.$breakpoint.mdAndUp && this.blok.minHeightDesktop) {
                    style.minHeight = this.blok.minHeightDesktop
                }
            }
            style.backgroundPosition = this.blok.backgroundImagePosition
            style.backgroundSize = this.blok.backgroundImageFit
            return style
        },
    },
}
